import { useEffect, useRef } from "react";
import { initAdtrace } from "../../lib/adtrace";
import { isAdtraceAllowed } from "../../features/analytics/adtraceEnabled";

export default function AdtraceBootstrap() {
  const did = useRef(false);

  useEffect(() => {
    if (did.current) return;
    if (!isAdtraceAllowed()) return;

    initAdtrace(); // without userId
    did.current = true;
  }, []);

  return null;
}
